// NOTE: localStorage here stores UI preferences only — never tokens, PII or other sensitive data.
import { useState, useCallback } from "react";

// UI preference only (non-sensitive) — safe to keep in localStorage.
const KEY = "okuapem_sidebar_collapsed";

export function useSidebarCollapsed() {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem(KEY) === "1");
  const toggle = useCallback(() => {
    setCollapsed((c) => {
      localStorage.setItem(KEY, c ? "0" : "1");
      return !c;
    });
  }, []);
  return { collapsed, toggle };
}
